import React from "react";
import { Link } from "@quintype/components";
import PropTypes from "prop-types";
import get from "lodash/get";
import { getSlug } from "../../../utils/utils";
import { FallbackImage } from "../FallbackImage";
import { useSelector } from "react-redux";

import "./magazine-cover-image.m.css";

export const MagazineCoverImageCard = ({ collection, config = {} }) => {
  const coverImageData = get(collection, ["metadata", "cover-image"]) || {};
  const { magazineSlug = "", useLink = true } = config;
  const { "cover-image-url": coverUrl, "cover-image-s3-key": covers3Key } = coverImageData;

  const slug = magazineSlug && collection && getSlug(collection, config);

  const cdnImage = useSelector((state) => state.qt.config["cdn-image"]);

  return (
    <div className="arr--magazine-cover-img" styleName="cover-image">
      {covers3Key || coverUrl ? (
        <figure styleName="image">
          {covers3Key ? (
            (() => {
              const coverImg = (
                <img
                  src={`https://${cdnImage}/${covers3Key}?w=400&auto=format,compress&fit=max&q=70`}
                  width={400}
                  style={{ aspectRatio: "1/2", objectFit: "cover", width: "100%" }}
                />
              );
              return useLink ? (
                <Link href={magazineSlug || slug} aria-label="magazine-cover-image" disableAjaxLinks={true}>
                  {coverImg}
                </Link>
              ) : (
                coverImg
              );
            })()
          ) : (
            <img src={`${coverUrl}?q=70`} loading="lazy" />
          )}
        </figure>
      ) : useLink ? (
        <Link href={magazineSlug || slug}>
          <div styleName="fallback-img">
            <FallbackImage slug={magazineSlug || slug} />
          </div>
        </Link>
      ) : (
        <div styleName="fallback-img">
          <FallbackImage slug={magazineSlug || slug} />
        </div>
      )}
    </div>
  );
};

MagazineCoverImageCard.propTypes = {
  collection: PropTypes.shape({
    "cover-image-url": PropTypes.string,
    "cover-image-s3-key": PropTypes.string,
    "cover-image-metadata": PropTypes.string,
    slug: PropTypes.string,
  }),
  config: PropTypes.shape({
    magazineSlug: PropTypes.string,
  }),
};
